module.exports = __webpack_public_path__ + "img/controller-yellow.65abf4ba.svg";